import { makeObservable, override } from 'mobx'
import { GROUP_API } from '@voicekey/api/group/group'
import { getURL, URL_TYPES } from '@voicekey/api/http'
import dynamicMessages from 'locales/dynamicMessages'
import { PersonsStore } from './personsStore'

export class GroupPersonsStore extends PersonsStore {
  constructor (rootStore, ...props) {
    super(rootStore, ...props)
    makeObservable(this, {
      getItems: override
    })
  }

  size = 10

  async getItems () {
    try {
      if (this.rootStore.groupsStore.selectedGroupId) {
        const filledFilterFields = this.getFilledFilterFields()
        const response = await GROUP_API.getGroupPersonsPage(
          getURL(URL_TYPES.GROUP),
          this.rootStore.groupsStore.selectedGroupId,
          this.getQueryParams(filledFilterFields),
          this.rootStore.sessionStore.sessionId
        )
        await this.setItems(response.data, { itemReducers: this.reducer })
      } else {
        this.items = []
      }
    } catch (e) {
      console.log(e)
      this.items = []
      this.rootStore.messagesStore.setMessage({ ...dynamicMessages.profile_get_all_fail, info: e })
    }
  }

  reducer = (person) => {
    const per = { id: person.person_id }
    if (!this.persons[per.id]) {
      this.addPerson(per)
    }
    return per
  }
}
